import { useTranslation } from 'react-i18next';

function DataHooks() {
  const { t } = useTranslation();

  const listSubSideBar = (type: string) => {
    const listType = {
      bisnisProcess: [
        { id: 1, name: t('side_bar.cvc'), value: '/business-process/cvc' },
        { id: 2, name: t('side_bar.tree_view'), value: '/business-process/tree-view' },
        { id: 3, name: t('side_bar.index_process'), value: '/business-process/indexview' },
      ],
      organization: [
        { id: 1, name: t('side_bar.structure_view'), value: '/structure-view' },
        { id: 2, name: t('side_bar.employees'), value: '/employees' },
      ],
      matrix: [
        { id: 1, name: t('side_bar.responsibility'), value: '/matrix' },
        { id: 2, name: t('side_bar.pivot_table'), value: '/pivot-table' },
      ],
      workloadAnalys: [
        {
          id: 1,
          name: t('side_bar.wla_analytics'),
          value: '/wla/dashboard-division',
          search: '?tab=1',
        },
        { id: 2, name: t('side_bar.wla_list'), value: '/wla/list' },
      ],
    };

    return listType[type] || [];
  };

  const sideBarHide = (pathname: string) => {
    const hiddenPath = new Set([
      '/board',
      '/company',
      '/profile',
    ]);
    if (hiddenPath.has(pathname)
      || pathname.startsWith('/detail-board')
      || pathname.startsWith('/audit-matrix')) {
      return 'd-none';
    }
    return '';
  };
  return { listSubSideBar, sideBarHide };
}

export default DataHooks;
